import Helper from '@/utils/helper'
import {mapState} from 'vuex'

export default {
    name: 'Servicing',
    computed: {
        ...mapState({
            servicing: state => state.app.servicing
        })
    },
    data() {
        return {
            servicingTimer: 0
        }
    },
    beforeMount() {
        if (!Helper.isDefined(this.servicing)) {
            this.$service._setGuiLoading()
            this.$pageManager.showInit()
            this.$service._unsetGuiLoading()
        }

        this.servicingTimer = setInterval(() => {
            this.$service.getStatus(this.servicing.id).then((status) => {
                if (Helper.isDefined(status.getCompleted()) && status.getCompleted() === true) {
                    this.$service._setGuiLoading()
                    this.$pageManager.showSuccess()
                    clearInterval(this.servicingTimer)
                    this.$service._unsetGuiLoading()
                }
            }).catch((e) => {
                this.$service._catchError(e)
                clearInterval(this.servicingTimer)
                this.$pageManager.showHome()
            })
        }, 5000)
    }
}
